import { gql } from '@apollo/client';
import React from 'react';
import TextWithIcon from '../components/TextWithIcon';
import type { TopicNameWithIcon_TopicFragment } from '../graphql/generated/graphqlTypes';
import addFragments from '../utils/addFragments';
import renderHighlight from '../utils/search/renderHighlight';
import type { TopicPrivacyIconProps } from './TopicPrivacyIcon';
import TopicPrivacyIcon from './TopicPrivacyIcon';

const TOPIC_FRAGMENT = gql`
  fragment TopicNameWithIcon_topic on PublicTopicFields {
    id
    name
    ...TopicPrivacyIcon_topic
  }
  ${TopicPrivacyIcon.fragments.topic}
`;

type TopicNameWithIconProps = {
  highlighted?: boolean;
  name?: React.ReactNode;
  topic: TopicNameWithIcon_TopicFragment;
  truncate?: 'single' | 'multi';
} & Pick<TopicPrivacyIconProps, 'iconSize' | 'showDefaultIcon' | 'tooltip'>;

const TopicNameWithIcon = ({
  highlighted,
  name,
  topic,
  truncate,
  iconSize,
  showDefaultIcon,
  tooltip,
}: TopicNameWithIconProps) => {
  let text: React.ReactNode = topic.name;
  if (name) {
    text =
      highlighted && typeof name === 'string' ? renderHighlight(name) : name;
  }

  return (
    <TextWithIcon
      text={text}
      icon={
        <TopicPrivacyIcon
          topic={topic}
          iconSize={iconSize}
          showDefaultIcon={showDefaultIcon}
          tooltip={tooltip}
        />
      }
      iconPosition="end"
      truncate={truncate}
    />
  );
};

export default addFragments(TopicNameWithIcon, {
  topic: TOPIC_FRAGMENT,
});
